import type { CustomDateType } from '@carrefour-gcs/shared';
import dayjs, { type Dayjs } from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

const CUSTOM_DATE_FORMAT = 'YYYY-M-D';

/**
 * Reads an API `CustomDateType` as local (not UTC) midnight, so the picker and the labels
 * never shift by one day around midnight.
 */
export function customDateToLocalDayjs({ year, month, day }: CustomDateType): Dayjs {
  return dayjs(`${year}-${month}-${day}`, CUSTOM_DATE_FORMAT, true).startOf('day');
}

/**
 * Writes a date back to the API `CustomDateType` shape (1-based month).
 */
export function dayjsToCustomDate(date: Dayjs): CustomDateType {
  return { year: date.year(), month: date.month() + 1, day: date.date() };
}
